<template>
    <el-form :model="model" :rules="rules" ref="refForm" size="small" label-width="140px" class="demo-ruleForm">
        
          <el-form-item label="服务器URL" prop="serverIp">
              <el-input
                class="input_box text_center_input"
                placeholder="请输入服务器URL"
                v-model="model.serverIp">
              </el-input>
          </el-form-item>
          <el-form-item label="路由器IP" prop="routerIp">
              <el-input
                class="input_box text_center_input"
                placeholder="请输入路由器IP"
                v-model="model.routerIp">
              </el-input>
          </el-form-item>
          <el-form-item label="自定义服务器URL" prop="threeServerIp">
              <el-input
                class="input_box text_center_input"
                placeholder="请输入自定义服务器URL"
                v-model="model.threeServerIp">
              </el-input>
          </el-form-item>
          <el-form-item label="设备IP" prop="deviceIp">
              <el-input
                class="input_box text_center_input"
                placeholder="请输入设备IP"
                v-model="model.deviceIp">
              </el-input>
          </el-form-item>
          
    </el-form> 
</template>

<script>
  import { deepClone,mapTo } from '@/libs/util'
  export default {
      props:{
          row:{
              type:Object,
              default:()=>{}
          },
          devId:{
              type:String,
              default:''
          }
      },
      data(){
          return {
              model:{
                "id": "",
                "serverIp": "",
                "routerIp": "",
                "threeServerIp": "",
                "deviceIp": ""
              },
              rules: {
       
                  serverIp: [
                   { required: true, message: '请输入服务器URL', trigger: 'blur' }

                  ],
                  routerIp: [
                   { required: true, message: '请输入路由器IP', trigger: 'blur' }
                
                  ],
                  threeServerIp: [
                   { required: true, message: '请输入自定义服务器URL', trigger: 'blur' }
                
                  ],
                  deviceIp: [
                   { required: true, message: '请输入设备IP', trigger: 'blur' }
                
                  ],
              
              },
          }
      },
      created(){
          this.model.id = this.devId
          if(this.row){
            mapTo(this.row,this.model)
          }
      },
      submit (dialog, callback) {
          this.$refs.refForm.validate( async(valid) => {
              if (valid) {
               const res = await this.$api.EditJKBLServerData(this.model)
               callback();
               dialog.okLoading = false;
               dialog.close();
               setTimeout(() => {
                    this.$msg.success('设置成功')
               }, 500);
              
              
              } 
          });
      
      },
      methods:{
      
      }
  }
</script>

<style lang="scss" scoped>
.demo-ruleForm{
  margin-top: 20px;
}
</style>